import { Component, Input, OnInit } from '@angular/core';
import { PricingItem, SelectedMsisdn } from '../../pricing-numbers/pricing-numbers';

@Component({
  selector: 'cc-get-number-order-details',
  templateUrl: './get-number-order-details.component.html',
  styleUrls: ['./get-number-order-details.component.scss'],
})
export class GetNumberOrderDetailsComponent implements OnInit {
  @Input() pricing: PricingItem;
  @Input() selectedMsisdn: SelectedMsisdn | undefined;
  @Input() initialSteps = false;

  constructor() {}

  ngOnInit() {}

  isFree() {
    return this.initialSteps && this.pricing.availableForInitialNumber;
  }
}
